import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/file.svg'
import _imports_1 from '../campaigns/assets/images/download-red.png'


const _withScopeId = n => (_pushScopeId("data-v-2b710160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_2 = { class: "p-p-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Drag and drop files to here to upload.", -1))
const _hoisted_4 = { class: "item-upload" }
const _hoisted_5 = { class: "info-upload" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isOwner)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          header: "ADD ATTACHMENTS",
          visible: _ctx.openBasicX,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openBasicX) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '50vw' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_FileUpload, {
                customUpload: true,
                onUploader: _ctx.onAdvancedUpload,
                multiple: true,
                maxFileSize: 1000000
              }, {
                empty: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onUploader"])
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_ctx.items?.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("section", {
            key: `${index}_upl`,
            class: "items-row"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(item?.name), 1)
              ]),
              _createElementVNode("a", {
                href: item?.url,
                download: "",
                title: "Download attachment"
              }, _hoisted_9, 8, _hoisted_7),
              (_ctx.isOwner)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.removeAttachment(item?._id)),
                    icon: "pi pi-times",
                    class: "p-button-rounded p-button-danger p-button-text"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}